import React from 'react'

export default function Other() {
  return (
    <div>Other</div>
  )
}
